/**
 * Shared i18n for ticket detail pages (timeline + star labels).
 * Components must define: getCurrentStep(), report
 */
export default {
  computed: {
    timelineSteps() {
      const s = this.getCurrentStep()
      void this.$store.state.locale.lang
      const doneStatusText =
        this.report && this.report.status === 'done'
          ? this.$t('ticketDetail.timeline.awaitingEval')
          : this.$t('ticketDetail.timeline.done')
      return [
        {
          num: 1,
          status: s >= 1 ? this.$t('ticketDetail.timeline.submitted') : this.$t('ticketDetail.timeline.waitShort'),
          role: this.$t('ticketDetail.role.user'),
        },
        {
          num: 2,
          status: s >= 2 ? this.$t('ticketDetail.timeline.received') : this.$t('ticketDetail.timeline.waitShort'),
          role: this.$t('ticketDetail.role.supervisor'),
        },
        {
          num: 3,
          status: s >= 3 ? this.$t('ticketDetail.timeline.inRepair') : this.$t('ticketDetail.timeline.waitShort'),
          role: this.$t('ticketDetail.role.technician'),
        },
        {
          num: 4,
          status: s >= 4 ? doneStatusText : this.$t('ticketDetail.timeline.waitShort'),
          role: this.$t('ticketDetail.role.userConfirm'),
        },
      ]
    },
  },
  methods: {
    getRatingText(r) {
      const key = `ticketDetail.rating.n${r}`
      const t = this.$t(key)
      return t !== key ? t : ''
    },
  },
}
